// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"EpicGroupCard_tagsWrapper__uFdSk"};